export default __webpack_public_path__ + "static/media/Head_2_Ear_2_C4.28eb648d.svg";